import { defineMessages } from 'react-intl'

export default defineMessages({
  copy: {
    id: 'SpaceChatbotCustomConversationPage.Copy',
    defaultMessage: 'Copy'
  },
  copied: {
    id: 'SpaceChatbotCustomConversationPage.Copied',
    defaultMessage: 'Copied!'
  }
})
